<div class="text-white m-auto px-6 py-12 space-y-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-sm">
        <img class="mx-auto h-20 w-auto" src="assets/images/logo/purso_white.svg" alt="{{ 'COMPANY.NAME' | translate }}">
    </div>

    <app-user-handling/>
</div>